"use client"

import type React from "react"
import { useEffect, useState } from "react"
import { Analytics } from "@vercel/analytics/react"
import { GoogleAnalytics } from "@/components/google-analytics"
import { useSettingsStore } from "@/lib/settings-store"

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme, hideScrollbar, goonGlassesIntensity } = useSettingsStore()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    console.log("[v0] Theme changed to:", theme)
  }, [theme])

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return

    const html = document.documentElement

    console.log("[v0] Applying theme to HTML:", theme)
    // Remove all theme classes
    html.classList.remove("dark", "auto")

    // Apply the selected theme
    if (theme === "dark") {
      html.classList.add("dark")
    } else if (theme === "auto") {
      html.classList.add("auto")
    }
    // 'light' is the default, so we don't add any class

    if (hideScrollbar) {
      html.classList.add("hide-scrollbar")
    } else {
      html.classList.remove("hide-scrollbar")
    }
  }, [theme, hideScrollbar, mounted])

  useEffect(() => {
    if (!mounted) return

    // Remove any existing overlay
    const existingOverlay = document.getElementById("goon-glasses-overlay")
    if (existingOverlay) {
      existingOverlay.remove()
    }

    // Create overlay if intensity > 0
    if (goonGlassesIntensity > 0) {
      const overlay = document.createElement("div")
      overlay.id = "goon-glasses-overlay"
      overlay.style.cssText = `
        position: fixed;
        inset: 0;
        pointer-events: none;
        z-index: 9999;
        background: linear-gradient(180deg, rgba(255, 200, 120, ${goonGlassesIntensity / 500}) 0%, rgba(255, 180, 80, ${goonGlassesIntensity / 400}) 100%);
        mix-blend-mode: multiply;
        transition: opacity 0.3s ease;
      `
      document.body.appendChild(overlay)
    }

    return () => {
      const overlay = document.getElementById("goon-glasses-overlay")
      if (overlay) {
        overlay.remove()
      }
    }
  }, [goonGlassesIntensity, mounted])

  return (
    <>
      {children}
      <Analytics />
      <GoogleAnalytics />
    </>
  )
}
